export default {
  title: "Оценка филиала",
  headerReview: {
    title: "Оставьте отзыв",
    text: "Расскажите о своих впечатлениях"
  },
  headerPlatforms: {
    title: "Спасибо за оценку!",
    text: "Будем рады, если вы оставите отзыв\nна одной из площадок:"
  },
  headerFeedback: {
    title: "Спасибо за оценку!",
    text: "Для нас важно мнение каждого клиента. Мы уже начали разбираться в ситуации, которую вы описали."
  },
  feedbackForm: {
    text: "Расскажите, что можно улучшить?",
    placeholder: "Комментарий",
    errorMessage: "Пожалуйста, заполните поле",
    checkboxText: "Хочу получить обратную связь по отзыву",
    checkboxSubtext: "Отзыв останется анонимным, если оставить это поле не отмеченным.",
    namePlaceholder: "Ваше имя",
    contactError: "Проверьте имя (мин. 2 символа) и номер телефона"
  },
  submitButton: "Отправить",
  alert: {
    selectRating: "Пожалуйста, выберите оценку",
    branchId: "Не найден id филиала"
  }
};
